import React, { useEffect, useState } from "react";
import { Modal } from "react_reusable_components";
import useOffline from "../../hooks/useOffline";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";

function OfflineNotification() {
  const [showOfflineMsg, setShowOfflineMsg] = useState(false);
  const isOffline = useOffline();
  const intl = useIntl();

  useEffect(() => {
    setShowOfflineMsg(isOffline);
  }, [isOffline]);

  return (
    <Modal
      title={getLocalizedMessage(intl, "offline.popup")}
      open={showOfflineMsg}
      onCancel={() => setShowOfflineMsg(false)}
      footer={null}
    >
      <p>{getLocalizedMessage(intl, "offline.popup.desc")}</p>
    </Modal>
  );
}

export default OfflineNotification;
